import React from 'react';
import { combineClassNames } from 'core/css';

const NotificationTrigger = ({
  text,
  disabled,
  className,
  classIdentifier,
}) => (
  <span
    className={`notification-trigger ${
      disabled ? 'notification-trigger--disabled' : ''
    } ${className || ''}`}>
    <button
      className={combineClassNames(
        'notification-trigger__link',
        classIdentifier && `${classIdentifier}-notification-trigger__link`
      )}
      disabled={disabled}>
      {text}
    </button>
  </span>
);

export const Dagger = (props) => <NotificationTrigger text="†" {...props} />;

export const DoubleDagger = (props) => (
  <NotificationTrigger text="‡" {...props} />
);

export const Asterisk = (props) => <NotificationTrigger text="*" {...props} />;

export const Carrot = (props) => <NotificationTrigger text="^" {...props} />;

export default NotificationTrigger;
